import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/carMonthDetail/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/save', params, options);

export const addRenior = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/addRenior', params, options);

export const copyCarmonth = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/copyRenior',
    Object.assign({}, options, { params }));

export const update = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/update', params, options);

export const getRuleDetail = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/detail', Object.assign({}, options, { params }));

export const carMonthList = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthList', Object.assign({}, options, { params }));

export const carMonthStartTime = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthStartTime', Object.assign({}, options, { params }));

export const getcarMonthLastEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/carMonthLastEndTime',
    Object.assign({}, options, { params })
  );

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/update',
    Object.assign({}, options, { params }));

export const getDetailAndOperate = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/detailAndOperate', Object.assign({}, options, { params }));

export const synchronize = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/synchronize', qs.stringify(params), options);

export const synchronizePlus = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/synchronizePlus', qs.stringify(params), options);

//车辆收费-欠费
export const loadCarPayBackAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carBackAmount', Object.assign({}, options, { params }));

//车辆收费-收费金额
export const loadCarPayAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/getPayMoney', Object.assign({}, options, { params }));

//车辆收费-月卡车下拉框
export const loadCarPayMonthCarNo = (params, options) =>
  request.get('/api/park/vehicle/getParkVehicleList', Object.assign({}, options, { params }));

//获取区域
export const nodeTreeByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId',
    method: 'get',
    params: {
      parentId,
    },
  });
};

//查询临停欠费记录
export const getListTempStopUnPayList = (params, options) =>
  request.get('/api/v4ward/car/listTempStopUnPayList', Object.assign({}, options, { params }));

export const listCarMonthByProperty = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/listByProperty', Object.assign({}, options, { params }));

export const exportMonthCarList = (formData) => {
  return request({
    url: '/api/v4ward/car/CarMonth/import',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};



export const queryCouponCode = (params, options) =>
  request.get('/api/v4ward/monthcar/v1/queryCouponCode', Object.assign({}, options, { params }));



  export const getMainList = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/page', Object.assign({}, options, { params }));

//车辆收费-收费金额
export const changeShouldPayMoneyBySupplement = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/changeShouldPayMoneyBySupplement', Object.assign({}, options, { params }));
